export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stato"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sito"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID negozio"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni negozio"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Link di pagamento"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivo"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non attivo"])}
}